'use client';

import { SegmentPage } from '@flipster/features/src/misc/segment/segment-page';
import { useIsWebview } from '@flipster/features/src/shared/webview';
import { css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';
import { ProdStaticPath } from '@flipster/utils/url';

import Explain from './_sections/explain';
import Footer from './_sections/footer';
import SymbolList from './_sections/symbol-list';

const Page = () => {
  const isWebview = useIsWebview();

  return (
    <>
      <SegmentPage name='zero_spread_page_view' />
      <main
        className={css({
          position: 'relative',
          minH: 'minHeightWithoutNavigation',
          pt: { base: 0, smallDesktop: 80 },
          tablet: {
            maxWidth: 'desktopMaxWidth',
            mx: 'auto',
          },
        })}
      >
        <div className={center({ overflow: 'hidden' })}>
          <img
            src={`${ProdStaticPath}/images/web/zero-spread-banner_251211.webp`}
            alt='zero-spread-hero'
            width={1200}
            height={440}
          />
        </div>
        <div className={css(layoutRawCss)}>
          <Explain />
          <SymbolList />
        </div>
        {isWebview && <Footer />}
      </main>
    </>
  );
};

export default Page;

const layoutRawCss = css.raw({
  px: { base: 16, smallDesktop: 0 },
  pb: { base: 186, smallDesktop: 150 },
});
